<template>
<div class="container-detalle">
  <div class="">
    <div class="row mb-3 justify-content-center">
      <div class="col-6 col-md-4 mb-4" v-for="(n, ix) in nominados" :key="ix">
        <div>
          <img width="120px" class="position-absolute d-inline-block mb-5" :src="`${publicPath}assets/images/stars-left.png`" />
          <!-- <router-link class="pt-5" :to="{name: 'perfil', params: {'id': n.id}}"> -->
            <img width="100%" :src="`${publicPath}assets/images/nominados/${n.id}.png`" class="mt-5" />
            <div class="nominado-icono text-center">
              {{ n.name }}              
            </div>            
          <!-- </router-link> -->
          <img width="120px" class="position-absolute-bottom d-inline-block mb-5" :src="`${publicPath}assets/images/stars-right.png`" />
        </div>
      </div>
      <!-- <div class="col-6 col-md-4 mb-4">
        <div>
          <img width="120px" class="position-absolute d-inline-block mb-5" :src="`${publicPath}assets/images/stars-left.png`" />
          <img width="100%" :src="`${publicPath}assets/images/iconos-avatar.png`" class="mt-5" />
          <img width="120px" class="position-absolute-bottom d-inline-block mb-5" :src="`${publicPath}assets/images/stars-right.png`" />
        </div>
      </div> -->
    </div>

  </div>
  
</div>

</template>

<style lang="scss">

  .nominados-icono-title {
    color: rgb(255, 255, 255);
    font-size: 18px;
    font-family: "Roboto";
  }

  .nominado-icono {
    font-size: 27px;
    text-transform: uppercase;
    font-family: "AkiraExpandedSuperBold";
    text-align: center;
    color: #fff;

    &:hover {
      color: #bd9767ff;
    }
  }

  .iconos-texto p {
    color: #fff;
    font-size: 18px;
    font-weight: 300;
    text-align: center;

  }

</style>

<script>



export default {
  name: 'NominadosIconos',
  props: {
    nominados: {
      type: Array
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>
